var _g, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGrab(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 27,
    fill: "none",
    viewBox: "0 0 23 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M9.715 3.158C9.958 2.202 10.777 1.5 11.75 1.5c.973 0 1.792.702 2.036 1.658A1.98 1.98 0 0 1 14.563 3c1.164 0 2.109 1.007 2.109 2.25v.878c.22-.083.456-.128.703-.128 1.165 0 2.11 1.007 2.11 2.25v6.258a8.679 8.679 0 0 1-1.02 4.093l-1.278 2.387c-.501.935-1.433 1.512-2.442 1.512H9.32c-.908 0-1.76-.468-2.289-1.256l-2.099-3.135a5.492 5.492 0 0 1-.916-3.051V10.5c0-1.243.944-2.25 2.109-2.25.247 0 .483.045.703.128V5.25c0-1.243.945-2.25 2.11-2.25.274 0 .536.056.777.158Z",
    clipRule: "evenodd"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2E2B32",
    fillRule: "evenodd",
    d: "M9.715 3.158C9.958 2.202 10.777 1.5 11.75 1.5c.973 0 1.792.702 2.036 1.658A1.98 1.98 0 0 1 14.563 3c1.164 0 2.109 1.007 2.109 2.25v.878c.22-.083.456-.128.703-.128 1.165 0 2.11 1.007 2.11 2.25v6.258a8.679 8.679 0 0 1-1.02 4.093l-1.278 2.387c-.501.935-1.433 1.512-2.442 1.512H9.32c-.908 0-1.76-.468-2.289-1.256l-2.099-3.135a5.492 5.492 0 0 1-.916-3.051V10.5c0-1.243.944-2.25 2.109-2.25.247 0 .483.045.703.128V5.25c0-1.243.945-2.25 2.11-2.25.274 0 .536.056.777.158Zm1.332 7.342c0 .414-.315.75-.703.75-.389 0-.703-.336-.703-.75V5.25c0-.414-.315-.75-.704-.75-.388 0-.703.336-.703.75v8.25c0 .414-.314.75-.703.75-.388 0-.703-.336-.703-.75v-3c0-.414-.315-.75-.703-.75-.388 0-.703.336-.703.75v4.558c0 .781.229 1.544.655 2.18l2.099 3.134c.264.394.69.628 1.144.628h5.425c.504 0 .97-.288 1.22-.756l1.28-2.387a7.102 7.102 0 0 0 .833-3.349V8.25c0-.414-.315-.75-.703-.75-.388 0-.703.336-.703.75v3c0 .414-.315.75-.703.75-.389 0-.703-.336-.703-.75v-6c0-.414-.315-.75-.704-.75-.388 0-.703.336-.703.75v5.25c0 .414-.314.75-.703.75-.388 0-.703-.336-.703-.75V3.75c0-.414-.315-.75-.703-.75-.388 0-.703.336-.703.75v6.75Z",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "a",
    width: 21.469,
    height: 27,
    x: 1.016,
    y: 0,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0705882 0 0 0 0 0.0745098 0 0 0 0 0.101961 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_96360_46135"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_96360_46135",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrab);
export default __webpack_public_path__ + "static/media/Grab.21a8c5edd615bf71d48f07bb6e409369.svg";
export { ForwardRef as ReactComponent };